import { IStoreWrap, useStore } from 'Shared/StoreProvider';
import { dbPatchFields } from 'Shared/forms/BaseOperations';
import { getValue2 } from 'Shared/forms/Inputs';
import { LocationBuilder, type StyleLocation } from 'Shared/backend/styles/LocationBuilder';
import { LocationPathStep } from 'Shared/model/venueSettings';


/*
	Where a standard style points itself - the 'selector' param the Colour, Margins, Padding and
	Borders styles all carry, read back by selectLocation() in tweaksStyle.ts.

	The store is the style tag's params, so the fields are written together: 'selectorClass' belongs
	to the 'class' selector and 'selectorPath' to 'path', and each is dropped when the selector moves
	off its own - deepPatch removes a field patched as undefined, on the server as well as in the
	store.

	A style whose params predate this control has no selector at all, which selectLocation() reads as
	'self' - so that is what the picker shows rather than nothing.

	It reads as one quiet line - 'Apply to Self ▾' - because the location is nearly always Self and
	should not compete with the value for attention. The 'Apply to' caption is the picker's own
	prefix, so the whole line is one click target. StyleFieldsRow pins it to the style's label row,
	right-justified.
*/
export function Selector()
{
	const sw = useStore();

	const selector = (): StyleLocation => getValue2(sw,'selector') ?? 'self';

	const selectorClass = (): string => getValue2(sw,'selectorClass') ?? '';

	const selectorPath = (): LocationPathStep[] => getValue2(sw,'selectorPath') ?? [];

	return (
		<LocationBuilder location={selector()} locationClass={selectorClass()}
			locationPath={selectorPath()}
			context='selector' plain={true} prefix='Apply to' panelAlign='right'
			choose={(location,aClass,path) => chooseSelector(sw,location,aClass,path)}
		/>
	);
}


async function chooseSelector<D>(sw:IStoreWrap<D>, selector:StyleLocation, aClass:string,
	path:LocationPathStep[])
{
	await dbPatchFields(sw,{
		selector:      selector,
		selectorClass: selector=='class' ? aClass : undefined,
		selectorPath:  selector=='path' ? path : undefined,
	});
}
